import script from "./ModalView.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalView.vue?vue&type=script&setup=true&lang=js"

import "./ModalView.vue?vue&type=style&index=0&id=1fd4e1ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd4e1ca"]])

export default __exports__